import Emitter from "es6-event-emitter";
import CookieManager from "../utilities/cookiemanager";

export default class SourcePointCMP extends Emitter {
  constructor(options) {
    super();
    this.erCookieName = options.erCookieName;
    window.__tcfapi("addEventListener", 2, (tcData, success) => {
      if (success && tcData.eventStatus === "useractioncomplete") {
        this.trigger("userConsent:changed");
      }
    });
  }

  getConsent() {
    const erCookie = CookieManager.getCookie(this.erCookieName);

    return {
      engageReaders: erCookie && JSON.parse(erCookie),
    };
  }

  showPreferences(id) {
    if (window._sp_) {
      window._sp_.loadPrivacyManagerModal(id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/cmp/sourcepoint-cmp.js